import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import SankeyDiagram from './SankyDiagram'; // Ensure the file SankeyDiagram.tsx exists in the same directory

const SankeyModal = ({ data }: { data: { nodes: string[]; links: { source: string; target: string; value: number; tooltip?: string }[]; nodeLinkCounts: Record<string, number> } }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <Button variant="success" onClick={handleShow}>
                前後の移動をグラフで表示
            </Button>

            <Modal show={show} onHide={handleClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>前後の移動グラフ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <SankeyDiagram data={{ 
                        ...data, 
                        links: data.links.map(link => ({ 
                            ...link, 
                            tooltip: link.tooltip || '' 
                        })) 
                    }} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SankeyModal;